export default __webpack_public_path__ + "static/img/Uppsala_domkyrka.d7cae5d.jpg";